import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import {useDispatch} from "react-redux";
import {setYoutube} from "../../libs/action";
import {YoutubeUrl} from "../../utils/constants";
// import { useSelector, useDispatch } from 'react-redux'
// import { YOUTUBE_LAYER } from 'reducers/common'

const YoutubeLayer = () => {
    const dispatch = useDispatch()

    const onClickClose = () => {
        dispatch(setYoutube(false))
    }
    return (
        <Style>
            <GlobalStyle />
            <div
                className="black"
                onClick={onClickClose}
            />
            <div className="youtube">
                <button
                    type="button"
                    className="closed"
                    onClick={onClickClose}
                />
                <iframe
                    width="720"
                    height="405"
                    src={YoutubeUrl}
                    frameBorder="0"
                    title="youtube"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </div>
        </Style>
    )
}

const GlobalStyle = createGlobalStyle`
    html, body {
        overflow: hidden;
        min-width: 800px;
        min-height: 580px;
    }
`

const Style = styled.div`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 200;

    .black {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
    }
    .youtube {
        position: relative;
        z-index: 10;
        text-align: center;
        background: #000;

        iframe {
            max-width: 100%;
        }
        .closed {
            position: absolute;
            width: 60px;
            height: 60px;
            right: 0;
            top: -60px;
            border: 0;
            background: #000;
            :hover{
                :before{
                    background: #418ded;
                }
                :after{
                    background: #418ded;
                }
            }

            &:before,
            &:after {
                content: '';
                position: absolute;
                top: 13px;
                left: 30px;
                width: 1px;
                height: 35px;
                background: #fff;
            }
            &:before {
                transform: rotate(-45deg);
            }
            &:after {
                transform: rotate(45deg);
            }

        }
    }
`

export default YoutubeLayer



// WEBPACK FOOTER //
// ./src/estimate_list/components/layer/youtubeLayer.js